<template>
  <div class="bg-gray">
    <div class="form-content">

      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="选择赛区" :rules="[
                { required: true, message: '请选择赛区'},
              ]">
              <div style="cursor: pointer" v-if="!formData.extra_saiqu.length" @click="showSaiquPicker = true">请选择执裁的赛区 <i class="el-icon-arrow-right"></i></div>
              <div style="cursor: pointer" v-else @click="showSaiquPicker = true">{{formData.extra_saiqu[0].name}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="裁判长姓名"
                prop="caipan_admin_name"
                :rules="[
                { required: true, message: '请输入裁判长姓名', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.caipan_admin_name"
                  type="text"
                  placeholder="请输入裁判长姓名"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="执裁裁判名称"
                prop="name"
                :rules="[
                { required: true, message: '请输入姓名', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.name"
                  type="text"
                  placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="日期"
                prop="date"
                :rules="[
                { required: true, message: '请选择日期' },
              ]"
            >
              <el-date-picker
                  v-model="formData.date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  :picker-options="pickerOptions"
                  placeholder="请选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
          <el-form-item label="执裁记录照片" prop="pic">
            <PicUploader :fileList="formData.pic" :limit="9"></PicUploader>

          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="onSubmit" :loading="saveLoading">提交申请
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>

      <SaiquPicker
          :show="showSaiquPicker"
          :limit="1"
          :value="formData.extra_saiqu"
          @onChange="onSaiquChange"
          @onClose="showSaiquPicker=false"
          :defaultValue="formData.extra_saiqu"
          @onConfirm="onSaiquConfirm"
      ></SaiquPicker>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}


.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from "@/components/LoginDialog.vue";
import SaiquPicker from '@/components/picker/SaiquPicker.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiScoreCaipanApply',
  components: {
    PicUploader, LoginDialog, SaiquPicker
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      showDate: false,
      showSaiquPicker: false,
      saveLoading: false,
      showArea: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      areaList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        saiqu: '',
        caipan_admin_name: '',
        name: '',
        date: '',
        pic: [],
        extra_saiqu: [],
      },

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    }
  },
  filters: {},
  mounted() {
    document.title = "执裁记录申请";
    let that = this;
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.getUserDetail();
      this.loginShow = false;
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    onQuestion() {
      console.log('onQuestion')
    },
    onDateConfirm(date) {
      console.log('onDateConfirm', date);
      this.showDate = false;
      this.formData.date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;


      for (let field in that.formData) {

        if (!this.formData.saiqu) {
          that.$message.warning('请选择赛区');
          return
        }

        if (!this.formData.pic.length) {
          that.$message.warning('请上传执裁记录照片');
          return
        }
      }
      that.saveLoading = true;

      that.$api.post('/api/sai/scoreCaipanApply', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('申请成功');
        setTimeout(() => {
          rbLink({
            name: "UserSearchCaipan",
          }, 'back')
        }, 200)
      }, (res) => {

        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        }
        Toast(res.msg);
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    onSaiquChange(values) {
      console.log('onSaiquChange', values)
      this.formData.saiqu = values[0].id;
      this.formData.extra_saiqu = [...values];
    },
    onSaiquConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showSaiquPicker = false;
      this.formData.saiqu = values[0].id;
      this.formData.extra_saiqu = [...values];
    },

    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

  }
}
</script>



// WEBPACK FOOTER //
// SaiScoreCaipanApply.vue?5a06686d